const prefix = 'lumahealth/BroadcastPage';

export const CLEAR_BROADCAST = `${prefix}/CLEAR_BROADCAST`;

export const DELETE_BROADCAST = `${prefix}/DELETE_BROADCAST`;
export const DELETE_BROADCAST_ERROR = `${prefix}/DELETE_BROADCAST_ERROR`;
export const DELETE_BROADCAST_SUCCESS = `${prefix}/DELETE_BROADCAST_SUCCESS`;

export const LOAD_BROADCAST = `${prefix}/LOAD_BROADCAST`;
export const LOAD_BROADCAST_ERROR = `${prefix}/LOAD_BROADCAST_ERROR`;
export const LOAD_BROADCAST_SUCCESS = `${prefix}/LOAD_BROADCAST_SUCCESS`;

export const SAVE_BROADCAST = `${prefix}/SAVE_BROADCAST`;
export const SAVE_BROADCAST_ERROR = `${prefix}/SAVE_BROADCAST_ERROR`;
export const SAVE_BROADCAST_SUCCESS = `${prefix}/SAVE_BROADCAST_SUCCESS`;

export const UPDATE_BROADCAST_STATUS = `${prefix}/UPDATE_BROADCAST_STATUS`;
export const UPDATE_BROADCAST_STATUS_ERROR = `${prefix}/UPDATE_BROADCAST_STATUS_ERROR`;
export const UPDATE_BROADCAST_STATUS_SUCCESS = `${prefix}/UPDATE_BROADCAST_STATUS_SUCCESS`;

export const BROADCAST_FORM_NAME = 'BroadcastPageForm';

export const MAX_PATIENTS_TO_LOAD = 20;
